import { z } from 'zod'
import { zSafeString, zNullableOptionalDefault } from '../../../utils/zodUtils'

const nameDaysOfWeekSchema = z.union([
  z.literal('mon'),
  z.literal('tue'),
  z.literal('wed'),
  z.literal('thu'),
  z.literal('fri'),
  z.literal('sat'),
  z.literal('sun'),
])

const timePeriodSchema = z.object({
  hourOpen: zSafeString(''),
  hourClose: zSafeString(''),
})

export type TimePeriod = z.infer<typeof timePeriodSchema>

const generalTimePeriodSchema = z.object({
  start: zSafeString(''),
  end: zSafeString(''),
})

export type GeneralTimePeriod = z.infer<typeof generalTimePeriodSchema>

export const dayOfWeekSchemaGeneral = z.object({
  day: nameDaysOfWeekSchema,
  timePeriods: zNullableOptionalDefault(z.array(generalTimePeriodSchema), []),
})

export const dayOfWeekSchemaTimeSlots = z.object({
  day: nameDaysOfWeekSchema,
  timePeriods: zNullableOptionalDefault(z.array(timePeriodSchema), []),
})
